exports.GmapLocation = require('./lib/GmapLocation').GmapLocation;


//////////////////
// WEBPACK FOOTER
// ./src/app/library/location-map/index.js
// module id = 203
// module chunks = 6